import axios from "axios";


// const baseURL = "http://localhost:8000/api/v1/";
// const baseURL = "http://13.126.44.109:800/api/v1"
// const baseURL = "https://backend.bedater.com/api/v1"
const baseURL = process.env.REACT_APP_BASE_BACKEND_API_URL


const axiosInstance = axios.create({
  baseURL,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
